import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Dumbbell, Repeat, Zap, Calendar, Target } from 'lucide-react';
import { Button } from './Button';
const benefits = [{
  icon: <Dumbbell className="w-8 h-8 text-brand-orange" data-id="element-11" />,
  title: 'El Inventario de Poder',
  description: 'Cómo convertir una mochila y dos botellas en un set de pesas profesional.'
}, {
  icon: <Repeat className="w-8 h-8 text-brand-orange" data-id="element-12" />,
  title: 'La Trilogía de Empuje y Tracción',
  description: 'El sistema para pecho, espalda y hombros sin usar barras.'
}, {
  icon: <Zap className="w-8 h-8 text-brand-orange" data-id="element-13" />,
  title: 'El Protocolo de Piernas de Acero',
  description: 'Ejercicios de alta intensidad usando solo el sofá y una silla.'
}, {
  icon: <Calendar className="w-8 h-8 text-brand-orange" data-id="element-14" />,
  title: 'El Plan Maestro de 21 Días',
  description: 'Un calendario paso a paso para que no tengas que pensar, solo actuar.'
}, {
  icon: <Target className="w-8 h-8 text-brand-orange" data-id="element-15" />,
  title: 'Guía de Adaptación de Cargas',
  description: 'Cómo saber exactamente cuánto peso añadir a tu mochila según tu nivel.'
}];
export function BenefitsSection() {
  return <section className="py-20 bg-brand-darker" data-id="element-16">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-17">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-16" data-id="element-18">
          <h2 className="text-4xl md:text-5xl uppercase" data-id="element-19">
            LO QUE TE <span className="text-brand-orange" data-id="element-20">LLEVAS HOY</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-id="element-21">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-zinc-900 border border-zinc-800 p-8 rounded-2xl hover:border-brand-orange/50 transition-colors" data-id="element-22">
              <div className="mb-6 bg-zinc-950 w-16 h-16 rounded-xl flex items-center justify-center border border-zinc-800" data-id="element-23">
                {benefit.icon}
              </div>
              <h3 className="text-xl mb-3 uppercase tracking-wide" data-id="element-24">
                {benefit.title}
              </h3>
              <p className="text-zinc-400 leading-relaxed" data-id="element-25">
                {benefit.description}
              </p>
            </motion.div>)}
        </div>

        <div className="flex justify-center" data-id="element-26">
          <Button data-id="element-27">¡SÍ, QUIERO EMPEZAR MI ENTRENAMIENTO AHORA!</Button>
        </div>
      </div>
    </section>;
}